/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Fade } from 'react-awesome-reveal';
import { FaRegPlayCircle, FaRegPauseCircle } from 'react-icons/fa';
import { FiVolume2, FiVolumeX } from 'react-icons/fi';

const SqueezeControls = ({ isPlaying, isMuted, content, setIsMuted, setIsPlaying, goNextSqueeze }) => {
  const { t } = useTranslation();
  const [currentAction, setCurrentAction] = useState(0);
  const [actionDuration, setActionDuration] = useState(null);
  const interval = useRef(null);

  const { duration: currentTime } = content[currentAction] || {};

  const countDown = () => {
    setActionDuration((prev) => {
      if (prev === 0) {
        clearInterval(interval.current);
        return prev;
      }
      const timeLeft = prev - 1;
      return timeLeft;
    });
  };

  useEffect(() => {
    setActionDuration(currentTime);
  }, [currentAction]);

  useEffect(() => {
    if (!isPlaying) {
      if (interval.current) clearInterval(interval.current);
      return;
    }
    interval.current = setInterval(countDown, 1000);
    return () => clearInterval(interval.current);
  }, [isPlaying]);

  useEffect(() => {
    if (actionDuration === 0) {
      setCurrentAction((prev) => {
        if (prev === content.length - 1) {
          goNextSqueeze((prevSqueeze) => prevSqueeze + 1);
          return 0;
        }
        return prev + 1;
      });
    }
  }, [actionDuration]);

  return (
    <Fade duration={500}>
      <footer className="squeeze-view__controls">
        <button type="button" className="squeeze-view__controls_playbtn" onClick={setIsPlaying}>
          {isPlaying ? <FaRegPauseCircle /> : <FaRegPlayCircle />}
        </button>
        <div className="squeeze-view__controls_indicators">
          <button type="button" onClick={setIsMuted}>
            {isMuted ? <FiVolumeX /> : <FiVolume2 />}
          </button>
          <span>{actionDuration}</span>
        </div>
        {content.map((currAction, index) => {
          const { action = '', duration = '' } = currAction;
          const actionLabel = action.split('_')[0];
          const actionPercentage = action.split('_')[1];
          const noRest = !['rest', 'hold'].includes(actionLabel);
          if (index === currentAction) {
            return (
              <p key={action + duration} className="squeeze-view__controls_actionlabel">
                {t(`evieApp.squeeze.actions.${actionLabel}`)} {noRest ? `${actionPercentage}%` : null}
              </p>
            );
          }
          return null;
        })}
      </footer>
    </Fade>
  );
};

SqueezeControls.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  isMuted: PropTypes.bool.isRequired,
  content: PropTypes.arrayOf(PropTypes.shape({ action: PropTypes.string, duration: PropTypes.string })).isRequired,
  setIsMuted: PropTypes.func.isRequired,
  setIsPlaying: PropTypes.func.isRequired,
  goNextSqueeze: PropTypes.func.isRequired,
};

export default SqueezeControls;
